import _ from 'lodash';
import {ReactNode} from 'react';
import React, {useState, useEffect, useRef} from 'react';
import {Button, Form, Popup} from 'semantic-ui-react';
import * as ProjectPickerQuery from '../graphql/projectPickerQuery';
import LegacyWBIcon from './elements/LegacyWBIcon';
import makeComp from '../util/profiler';

interface ProjectPickerProps {
  entityName: string;
  projectName: string;
  triggerOverride?: ReactNode;
  onOpen?: () => void;
  onClose?: () => void;
  setProject(entityName: string, projectName: string): void;
}

const ProjectPicker: React.FC<ProjectPickerProps &
  ProjectPickerQuery.QueryResultProps> = makeComp(
  ({
    entityName,
    projectName,
    triggerOverride,
    onOpen,
    onClose,
    setProject,
    projectPickerQuery,
  }) => {
    const [open, setOpen] = useState(false);

    const firstRenderRef = useRef(true);
    useEffect(() => {
      if (firstRenderRef.current) {
        return;
      }
      if (open) {
        onOpen?.();
      } else {
        onClose?.();
      }
      // eslint-disable-next-line
    }, [open]);
    useEffect(() => {
      firstRenderRef.current = false;
    }, []);

    const projects = projectPickerQuery.projects
      ? projectPickerQuery.projects
      : [];
    let curIndex = _.findIndex(
      projects,
      p => p.entityName === entityName && p.name === projectName
    );
    if (curIndex === -1) {
      projects.unshift({
        entityName,
        name: projectName,
        id: '',
        createdAt: '',
      });
      curIndex = 0;
    }
    const options = projects.map((p, i) => ({
      text: p.entityName + ' / ' + p.name,
      value: i,
    }));
    return (
      <Popup
        basic
        open={open}
        onOpen={() => setOpen(true)}
        onClose={() => setOpen(false)}
        className="wb-table-action-popup"
        on="click"
        position="bottom left"
        popperModifiers={{
          preventOverflow: {
            // prevent popper from erroneously constraining the popup to the
            // table header
            boundariesElement: 'viewport',
          },
        }}
        trigger={
          triggerOverride ? (
            triggerOverride
          ) : (
            <Button size="tiny" className={'wb-icon-button'}>
              <LegacyWBIcon name="folder" />
              {entityName + ' / ' + projectName}
            </Button>
          )
        }
        content={
          <Form>
            <Form.Dropdown
              selection
              search
              value={curIndex}
              options={options}
              onChange={(e, {value}) => {
                if (typeof value === 'number') {
                  const proj = projects[value];
                  setProject(proj.entityName, proj.name);
                  setOpen(false);
                }
              }}
            />
          </Form>
        }
      />
    );
  },
  {id: 'ProjectPicker', memo: true}
);

export default ProjectPickerQuery.withQuery(ProjectPicker);
